import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e641371e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=e641371e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e641371e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e641371e')) {
      api.createRecord('e641371e', component.options)
    } else {
      api.reload('e641371e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e641371e&scoped=true&", function () {
      api.rerender('e641371e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g0DFo5KmzGhd/JS/comp/SearchFilterTokens.vue"
export default component.exports